import { Badge } from "@components";
import { CheckCircle, SlashCircle01, Tool02 } from "@untitledui/icons";
import { useChecklistStore } from "../store";
import { VehicleConditionsTypeColor } from "../types";

export const LastAnswers = () => {
	const checklist = useChecklistStore((state) => state.checklist);
	const { summary } = checklist?.answerData || {};
	const questions = summary?.lastSubmitted.optionQuestions;

	if (!questions?.length) {
		return;
	}

	return (
		<div className="mx-auto flex w-full max-w-[456px] flex-col gap-1 p-4 pt-0">
			<h4 className="font-body font-bold text-quaternary text-sm leading-5">
				QUESTIONÁRIO
			</h4>

			<div className="flex flex-col gap-2">
				{questions.map((q) => (
					<div
						className="flex w-full items-center justify-between"
						key={q.optionId}
					>
						<p className="font-body text-md text-secondary leading-normal">
							{q.prompt}
						</p>
						<Badge
							className="h-7 rounded-full py-1 pr-3 pl-2.5 font-body font-medium text-sm leading-5"
							variant={VehicleConditionsTypeColor[q.label]}
						>
							{q.label === "Avariado" && <Tool02 />}
							{q.label === "Não possui" && <SlashCircle01 />}
							{q.label === "Regular" && <CheckCircle />}
							{q.label}
						</Badge>
					</div>
				))}
			</div>
		</div>
	);
};
